import React from 'react';

const RBAC = () => (
    <div style={cardStyle}>
        <h2 style={{color: '#1a2234'}}>🔐 Role-Based Access Control (RBAC)</h2>
        <p style={tagStyle}>Status: Under Development</p>
        <p>Permission matrix: Aap set karenge ke Salesman ko Purchase Cost nazar aaye ya nahi.</p>
        <div style={{marginTop: '20px', padding: '15px', border: '1px dashed #cbd5e1', borderRadius: '8px', textAlign: 'center', color: '#94a3b8'}}>
            [ Permission Matrix Table Will Appear Here ]
        </div>
    </div>
);

const cardStyle = { backgroundColor: 'white', padding: '25px', borderRadius: '12px', boxShadow: '0 4px 6px rgba(0,0,0,0.05)' };
const tagStyle = { backgroundColor: '#fef3c7', color: '#92400e', padding: '5px 10px', borderRadius: '5px', display: 'inline-block', fontSize: '12px' };

export default RBAC;